var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Schedule',{attrs:{"id":_vm.id,"fields":_vm.fields,"data":_vm.data,"code":_vm.code,"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }